import { GETFINDOBJECTIVE_SUCCESS, GETFINDOBJECTIVE_FAIL } from '../actionTypes';

const initialState = {
    user: []
};

const getFindObjectiveReducer = (state = initialState, action) => {
    switch (action.type) {
        case GETFINDOBJECTIVE_SUCCESS:
            return {
                ...state,
                isLoggedIn: true,
                user: action.payload.user,
            };
        case GETFINDOBJECTIVE_FAIL:
            return {
                ...state,
                isLoggedIn: false,
                user: [],
            };
        default:
            break;
    }

    return state;
};

export default getFindObjectiveReducer;



